import { createChatBotMessage } from 'react-chatbot-kit';
import ESBotAvatar from '../components/ESBotAvatar'
import Help from '../components/Help';
import MarkdownWidget from '../components/MarkdownWidget';
import ChatHeader from '../components/ChatHeader';
import BotBubble from '../components/BotBubble';
import UserAvatar from '../components/UserAvatar';
import UserBubble from '../components/UserBubble';
// import markdownTest from './markdowntest';

const botName = 'ESB';
const defaultMessage = `I am EarSketch bot. Let's get started`

const config = {
  initialMessages: [createChatBotMessage(defaultMessage, {
    widget: "Help"
  })],
  botName: botName,
  customComponents: {
    header: () => <ChatHeader />,
    botAvatar : (props) => <ESBotAvatar {...props} />,
    botChatMessage: (props) => <BotBubble {...props} />,
    userAvatar: (props) => <UserAvatar {...props} />,
    userChatMessage: (props) => <UserBubble {...props} />,
  },
  customMessages: {
    markdownOnly: (props) => <MarkdownWidget {...props} />,
  },
  customStyles: {
    // Overrides the chatbot message styles
    botMessageBox: {
      backgroundColor: "#D3D3D3",
    },
    // Overrides the chat button styles - upadte when accent color is updated
    chatButton: {
      backgroundColor: "#F56476",
    },
  },
  widgets: [
    {
      widgetName: 'Help',
      widgetFunc: (props) => <Help {...props} />,
      mapStateToProps: ['gist'],
    },
    {
      widgetName: "MarkdownWidget",
      widgetFunc: (props) => <MarkdownWidget {...props} />,
      mapStateToProps: [],
    },
  ],
};

export default config;
